var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.calculatesZipcodeCache)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n    Hinweis: Da der Cache für dynamische PLZ berechnet wird, wird die\n    Einstellung `dynamisch` erst später angewendet. Die Fakes behalten für\n    diese Zeit den alten Wohnort.\n  ")]):_vm._e(),_vm._v(" "),_c('section',[_c('resource',{attrs:{"title":"Ändern","resource":"customerProfile","resourceName":"Fake","staticMode":_vm.isDeleted,"original":_vm.original,"attributes":[
        {
          name: 'sex',
          label: 'Geschlecht',
          type: 'SexSelector'
        },
        {
          name: 'name',
          label: 'Name'
        },
        {
          name: 'country_iso3166',
          label: 'Land',
          type: 'OptionSelector',
          hideable: true,
          hideEvent: 'has-dynamic-zipcode'
        },
        {
          name: 'zipcode',
          label: 'PLZ',
          col: 3,
          hideable: true,
          hideEvent: 'has-dynamic-zipcode'
        },
        {
          name: 'privacy_postal_code_number_de',
          label: 'Angezeigte PLZ Nummern',
          col: 1
        },
        {
          name: 'privacy_postal_code_number_at_ch',
          label: 'Angezeigte PLZ Nummern AT/CH',
          col: 1,
          hideable: true,
          reverseHide: true,
          hideEvent: 'has-dynamic-zipcode'
        },
        {
          name: 'has_dynamic_zipcode',
          label: 'Dynamische PLZ',
          type: 'CheckboxSelector',
          cantDisable: true
        },
        {
          name: 'birthday',
          label: 'Geburtsdatum',
          type: 'BirthdaySelector',
          withRandomSelector: true
        },
        {
          name: 'physique',
          label: 'Figur',
          type: 'OptionSelector'
        },
        {
          name: 'i_search_for_activity',
          label: 'Ich suche',
          type: 'MultiOptionSelector',
          multiSelect: true
        },
        {
          name: 'interested_in_gender',
          label: 'Interessiert an',
          type: 'SexSelector',
          multiSelect: true
        },
        {
          name: 'height_in_cm',
          label: 'Größe (cm)',
          type: 'SliderSelector',
          max: 220,
          min: 140
        },
        {
          name: 'admin_notes',
          label: 'Admin Info',
          type: 'TextareaSelector',
          rows: 5
        }
      ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("\n          Fake-Profil bearbeiten\n          "),(_vm.isDeleted)?_c('span',{staticClass:"badge badge-danger ml-3"},[_vm._v("GELÖSCHT")]):_vm._e()])])]),_vm._v(" "),(!_vm.isDeleted)?_c('MediaEditCard',{attrs:{"profile":_vm.customer,"title":"Fakes Media"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }